import { PropsWithClassName } from '../../../types/PropsWithClassName';
import { classNames } from '../../../utils/classNames';

type IconTextBadgeProps = PropsWithClassName & {
  icon: string;
  text: string;
  variant?: 'orange' | 'blue';
};

export const IconTextBadge = ({ className, icon, text, variant = 'orange' }: IconTextBadgeProps) => {
  return (
    <div
      className={classNames(
        'flex text-xs font-semibold whitespace-nowrap items-center gap-2 rounded-full px-4 py-2',
        variant === 'orange' ? 'bg-[#FFAF46]' : 'bg-[#4E7DF6]',
        'text-white',
        className
      )}
    >
      <span>{icon}</span>
      <span className="font-medium">{text}</span>
    </div>
  );
}; 